const useScrollToElementById = () => {
  const scrollToElement = (elementId, bannerClass) => {
    const element = document.getElementById(elementId);
    const isBanner = document.getElementsByClassName(bannerClass);
    const offset = isBanner.length > 0 ? 40 : 0;
    if (element) {
      setTimeout(() => {
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth',
        });
      }, 100);
    }
  };
  return scrollToElement;
};

export default useScrollToElementById;
